import React from 'react';
import Support from 'assets/images/backoffice/capital/ic-support.svg';
import styles from './FaqCard.css';
import Button from '../Button';

function FaqCard() {
  return (
    <div className={styles['main-container']}>
      <p className={styles.title}>Informasi lebih lanjut</p>
      <div className={styles['icon-wrapper']}>
        <img src={Support} className={styles.icon} />
      </div>
      <Button
        center
        btnType="outline"
        title="Baca FAQ"
        href="https://mokaposhelp.zendesk.com/hc/en-us/sections/360003335313-Moka-Capital"
        target="_blank"
      />
    </div>
  );
}

export default FaqCard;
